// La version du texte de l accord au texto que la page « Mes parametres » AFFICHE
// (cles hub:parametres.accord.*). Elle doit egaler VERSION_DU_TEXTE_DE_L_ACCORD de
// @gs/api-shared, que le serveur exige (temoin accordTexto.test.ts) : changer le texte,
// c est changer les deux, et chacun reaccepte. Si le serveur en exige une autre (deploiement
// decale), la page n offre pas l accord — on n enregistre jamais l accord a un texte non lu.
export const VERSION_DU_TEXTE_AFFICHE = 'avis-texto-2026-10-22';

/** L accord ne s offre que si le texte affiche est celui que le serveur exige. */
export function accordOffrable(versionCouranteDuServeur: string | undefined): boolean {
  return versionCouranteDuServeur === VERSION_DU_TEXTE_AFFICHE;
}
